module.exports = __webpack_public_path__ + "img/couples-045.202a8d51.jpg";